module.exports = __webpack_public_path__ + "img/fj.3055dc2b.png";